import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "components/form/InputField";
import SelectField from "components/form/SelectField";
import TextAreaField from "components/form/TextAreaField";
import DateField from "components/form/DateField";
import FormActionButtons from "components/Button/FormActionButtons";

// Helper: generate password acak
const generatePassword = () => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  return Array.from({ length: 8 }, () =>
    chars.charAt(Math.floor(Math.random() * chars.length))
  ).join("");
};

// Helper: array ke option format
const toOptions = (arr) =>
  arr.map((label) => ({
    id: label.toLowerCase().replace(/\s+/g, "-"),
    label,
  }));

// Prefix nama ID Mitra
const mitraPrefixMap = {
  Petani: "MP",
  Angkutan: "MA",
  Pemborong: "MPB",
  Supplier: "MS",
};

const AddMitra = () => {
  const navigate = useNavigate();
  const [jenisMitra, setJenisMitra] = useState("");
  const [idMitra, setIdMitra] = useState("0001");
  const [namaIdMitra, setNamaIdMitra] = useState("");
  const [userName, setUserName] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const statusAnggotaOptions = toOptions(["Anggota", "Non Anggota"]);
  const jenisMitraOptions = toOptions([
    "Petani",
    "Angkutan",
    "Pemborong",
    "Supplier",
  ]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("loggedInUser"));
    const name = user?.nama || "";

    setUserName(name); // untuk ditampilkan
    setValue("DiInputOleh", name); // untuk disimpan
    setValue("password", generatePassword());
    setValue("Pengguna", "MITRA");
  }, [setValue]);

  useEffect(() => {
    if (!jenisMitra) return;

    const existingMitra = JSON.parse(localStorage.getItem("mitra")) || [];
    const count = existingMitra.filter(
      (m) => m.JenisMitra === jenisMitra
    ).length;
    const nextNumber = (count + 1).toString().padStart(4, "0");
    const prefix = mitraPrefixMap[jenisMitra] || "MXX";
    const namaID = `${prefix}_A${nextNumber}`;

    setIdMitra(nextNumber);
    setNamaIdMitra(namaID);
    setValue("IDMitra", nextNumber);
    setValue("NamaIDMitra", namaID);
  }, [jenisMitra, setValue]);

  const onSubmit = (data) => {
    const existingMitra = JSON.parse(localStorage.getItem("mitra")) || [];
    const emailExists = existingMitra.some((m) => m.email === data.email);

    if (emailExists) {
      alert("Email sudah terdaftar!");
      return;
    }

    const updatedMitra = [data, ...existingMitra];
    localStorage.setItem("mitra", JSON.stringify(updatedMitra));
    navigate("/data-mitra");
  };

  return (
    <div className="pl-64 mt-8">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-4xl p-6 mx-auto bg-white border border-gray-200 shadow-lg rounded-2xl"
      >
        <h2 className="mb-6 text-xl font-semibold text-center text-gray-800 sm:text-2xl">
          Tambah Data Mitra
        </h2>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* Kolom Kiri */}
          <div className="space-y-4">
            <InputField
              label="Nama"
              {...register("nama", { required: "Nama wajib diisi" })}
              error={errors.nama}
            />
            <InputField
              label="Jenis Pengguna"
              value="MITRA"
              readOnly
              {...register("Pengguna", { required: true })}
              error={errors.Pengguna}
            />
            <InputField
              label="ID Mitra"
              value={idMitra}
              readOnly
              {...register("IDMitra", { required: true })}
              error={errors.IDMitra}
            />
            <SelectField
              label="Jenis Mitra"
              options={jenisMitraOptions}
              {...register("JenisMitra", {
                required: "Jenis Mitra wajib diisi",
                onChange: (e) => setJenisMitra(e.target.value),
              })}
              error={errors.JenisMitra}
            />
            <InputField
              label="Kode Pos"
              {...register("KodePos", { required: "Kode Pos wajib diisi" })}
              error={errors.KodePos}
            />
            <InputField
              label="Password"
              type="password"
              readOnly
              {...register("password", { required: true })}
              error={errors.password}
            />
          </div>

          {/* Kolom Kanan */}
          <div className="space-y-4">
            <InputField
              label="No. Telp"
              {...register("telp", { required: "No. Telp wajib diisi" })}
              error={errors.telp}
            />
            <SelectField
              label="Status Keanggotaan"
              options={statusAnggotaOptions}
              {...register("StatusKeanggotaan", {
                required: "Status wajib diisi",
              })}
              error={errors.StatusKeanggotaan}
            />
            <InputField
              label="Nama ID Mitra"
              value={namaIdMitra}
              readOnly
              {...register("NamaIDMitra", { required: true })}
              error={errors.NamaIDMitra}
            />
            <DateField
              label="Tanggal Jadi Mitra"
              {...register("TanggalJadiMitra", {
                required: "Tanggal wajib diisi",
              })}
              error={errors.TanggalJadiMitra}
            />
            <InputField
              label="Email"
              type="email"
              {...register("email", {
                required: "Email wajib diisi",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Format email tidak valid",
                },
              })}
              error={errors.email}
            />
            <InputField
              label="Diinput Oleh"
              readOnly
              value={userName}
              {...register("DiInputOleh", { required: "Wajib diisi" })}
              error={errors.DiInputOleh}
            />
          </div>
        </div>

        <div className="mt-6">
          <TextAreaField
            label="Alamat"
            {...register("alamat", { required: "Alamat wajib diisi" })}
            error={errors.alamat}
          />
        </div>

        <FormActionButtons
          submitLabel="Simpan"
          cancelLabel="Batal"
          onCancel={() => navigate("/data-mitra")}
          fullWidth={true}
        />
      </form>
    </div>
  );
};

export default AddMitra;
